import moment from "moment-timezone";

const initialState = {
  token: '',
  role: '',
  username: '',
  userID: '',
  SummaryDownline: '',
  date: moment().format('YYYY-MM-DD'),
  currentLanguage: 'cn',
  AbleConvertPDF: '0',
}
  
function reducer(state = initialState, action) {
  switch (action.type) {
  case 'SET_LANGUAGE':
    sessionStorage.setItem("currentLanguage", action.payload);
    return {
      ...state,
      currentLanguage: action.payload,
    };
  case 'LOGIN_STATUS':
    return {
      ...state,
      username: action.payload.username,
      role: action.payload.role,
      token: action.payload.token,
      userID: action.payload.userID,
      AbleConvertPDF: action.payload.AbleConvertPDF,
      SummaryDownline: action.payload.SummaryDownline,
    };
  case 'SET_DATE':
    return {
      ...state,
      date: action.payload.date,
    };
  default:
    return state;
  }
}
  
export default reducer
  